<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); let idx = index; trackBy: trackByFunc">
		<button type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue(idx)"><mat-icon color="accent" svgIcon="md:remove"></mat-icon></button>
		<mat-form-field appearance="outline" class="mat-form-field-custom-width copo-no-error-message" subscriptSizing="dynamic">
			<mat-select [attr.aria-busy]="isLoading" [aria-label]="filter.label" [placeholder]="filter.placeholder" (selectionChange)="selectionChanged(item, $event.value)" [value]="item.code">
				<mat-option *ngFor="let filterItem of filteredItems" [value]="filterItem.code">
					{{ filterItem.translation }}
				</mat-option>
			</mat-select>
			<copo-loading-spinner matSuffix class="loading-spinner-container-input" *ngIf="isLoading"></copo-loading-spinner>
		</mat-form-field>
	</div>
</ng-container>
